<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1 style="padding-bottom:0px;font-size:20px;letter-spacing:0px;">Acknowledgements</h1>
<p style="text-align: center;">Carrie Crowe (niece) and Amanda Dover (daughter).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?02abaa01